import { render, staticRenderFns } from "./CourseFile.vue?vue&type=template&id=19ebdef4"
import script from "./CourseFile.vue?vue&type=script&lang=js"
export * from "./CourseFile.vue?vue&type=script&lang=js"
import style0 from "./CourseFile.vue?vue&type=style&index=0&id=19ebdef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports